define('constants/userPresenceStatus',[],() => {
    return Object.freeze({
        Unknown: 0,
        Available: 1,
        AtLunch: 2,
        Away: 3,
        InAMeeting: 4,
        DoNotDisturb: 5,
        GoneHome: 6,
        OutOfOffice: 7
    });
});
